import { Mail, Phone, MessageCircle } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { CONTACT } from "./data";
import { QuoteWizard } from "./QuoteWizard";

const DETAILS = [
  [Mail, "Email", CONTACT.email, `mailto:${CONTACT.email}`],
  [Phone, "Phone", CONTACT.phone, `tel:${CONTACT.phone.replace(/\s/g, "")}`],
  [MessageCircle, "WhatsApp", CONTACT.whatsapp, `https://wa.me/${CONTACT.whatsapp.replace(/\D/g, "")}`],
];

export const Contact = () => {
  return (
    <section id="contact" className="bg-white px-3 py-3 sm:px-5 sm:py-5" data-testid="contact-section">
      <div className="mx-auto grid max-w-[1440px] gap-14 overflow-hidden rounded-[32px] bg-navy px-6 py-16 text-white sm:px-12 sm:py-24 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Eyebrow light>Start a conversation</Eyebrow>
          <Reveal>
            <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-6xl">
              Let's build a <em className="font-serif font-normal italic text-copper-light">long&#8209;term</em> trade.
            </h2>
          </Reveal>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-300">Supplier, yard, recycler or buyer — tell us what you have or what you need.</p>
          <ul className="mt-12 space-y-5">
            {DETAILS.map(([Icon, k, v, href]) => (
              <li key={k} className="flex items-start gap-4">
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/20"><Icon className="h-4 w-4 text-copper-light" /></span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">{k}</p>
                  <a href={href} target={k === "WhatsApp" ? "_blank" : undefined} rel="noopener noreferrer" className="link-underline text-white" data-testid={`contact-${k.toLowerCase()}-link`}>{v}</a>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <QuoteWizard />
      </div>
    </section>
  );
};
